const UserDataWrapper = require("./UserDataWrapper");
const TravelDataWrapper = require("./TravelDataWrapper");
const Wrapper = require("./Wrapper");

class FormModel {
    constructor() {
        this.type = 1;
        this.travelData = null;
        this.userData = null;
    }
}

class FormWrapper extends Wrapper {
    constructor(model = new FormModel()) {
        super();
        this.model = model;

        this.initWrappers();
        this.initEvents();

        window.form = this;
    }

    initWrappers() {
        this.travelData = this.model.travelData
            ? new TravelDataWrapper(this.model.travelData)
            : new TravelDataWrapper();
        this.travelData.syncUIWithModel();

        this.userData = this.model.userData
            ? new UserDataWrapper("userData", this.model.userData)
            : new UserDataWrapper("userData");
        this.userData.syncUIWithModel();
    }

    validate() {
        this.travelData.validate();
        this.userData.validate();
        document.getElementById("announcementForm").reportValidity();
    }

    get agree() {
        return Boolean(document.getElementById("agreement").checked);
    }

    isValid() {
        return (
            this.travelData.isValid() &&
            this.userData.isValid() &&
            document.getElementById("announcementForm").checkValidity()
        );
    }

    initEvents() {
        this.travelData.addListener(() => {
            this.updateModel({ travelData: this.travelData.model });

            // Disable selected goods
            const selectedGoods = this.travelData.goods.map(gw => gw.model.goodType);
            this.travelData.goods.forEach(gw => {
                let select = gw.$goodTypeInputElement.get(0);

                for (let opt of select.options) {
                    if (selectedGoods.includes(Number(opt.value))) {
                        window.$(opt).attr("disabled", "disabled");
                    } else {
                        window.$(opt).removeAttr("disabled");
                    }
                }
                window.$(select).selectric("refresh");
            })
        });

        this.userData.addListener(() => {
            this.updateModel({ userData: this.userData.model });
        });

        this.addListener(() => { });

        document.getElementById("agreement").addEventListener("change", () => {
            if (this.agree) {
                $("#formSubmit").removeAttr("disabled");
            } else {
                $("#formSubmit").attr("disabled", "true");
            }
        });
    }
}

module.exports = FormWrapper;
